<template>
  <div class="columns is-multiline">
    <div class="column is-3">
      <div class="box has-text-centered">
        <a class="button is-outlined is-success is-small" @click="openAddZipcodeDialog">
          <span class="icon is-small">
            <i class="fas fa-plus"></i>
          </span>
          <span>Add</span>
        </a>
      </div>
    </div>
    <div class="column is-3" v-for="zipcode in city.zipcodes" :key="zipcode.zipcode">
      <div class="box zipcode-container">
        <p class="has-text-centered">{{zipcode.locality}}</p>
        <div>
          <div>
            <a class="button is-small is-outlined is-danger" @click="deleteZipcode(zipcode)">
              <span class="icon is-small">
                <i class="fas fa-trash-alt"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ZipcodesService from './service';
import ManageZipcode from './ManageZipcode';

export default {
  name: 'zipcodes',

  props: ['city'],

  methods: {
    openAddZipcodeDialog(zipcode = null) {
      this.$modal.open({
        parent: this,
        props: {
          city: this.city
        },
        component: ManageZipcode,
        hasModalCard: true
      });
    },
    
    deleteZipcode(zipcodeTobeDeleted) {
      this.$dialog.confirm({
        message: 'Sure to delete zipcode?',
        onConfirm: () => {
          ZipcodesService.deleteZipcode(this.city, zipcodeTobeDeleted).then(
            () => {
              this.city.zipcodes = this.city.zipcodes.filter(
                zipcode => zipcode !== zipcodeTobeDeleted
              );
              this.$toast.open('Zipcode deleted successfully');
            }
          );
        }
      });
    }
  }
};
</script>

<style scoped>
.zipcode-container {
  display: flex;
  justify-content: space-between;
}
</style>




// WEBPACK FOOTER //
// src/pages/cities/Zipcodes/Zipcodes.vue